var render = function render(){var _vm=this,_c=_vm._self._c;return _c('HvhContextMenu',{attrs:{"event":_vm.$store.state.rightClickEvent.event}},[_c('li',{on:{"click":_vm.open}},[_c('label',[_vm._v("Open")])]),_c('li',{on:{"click":_vm.openInNewTab}},[_c('label',[_vm._v("Open link in new tab")])])])
}
var staticRenderFns = []

export { render, staticRenderFns }